import script from "./PlatMapAmenityInfoWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatMapAmenityInfoWindow.vue?vue&type=script&lang=ts&setup=true"

import "./PlatMapAmenityInfoWindow.vue?vue&type=style&index=0&id=10658965&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10658965"]])

export default __exports__